import React from 'react';
import PropTypes from 'prop-types';

import useWorkflowGuard from 'hooks/useWorkflowGuard';

const MicroDepositOnTheWayPage = ({ navigate, searchParams }) => {
  useWorkflowGuard(searchParams, navigate);

  return (
    <div className="flex flex-col items-center text-center mb-8">
      <p className="text-sm md:text-base text-slate-600 px-0 md:px-[90px] mb-8">
        You will receive an email and a text once the micro-deposit has been completed.
      </p>

      <div className="w-full max-w-[500px] bg-slate-50 border border-slate-200 rounded-lg p-6">
        <p className="text-base font-bold text-slate-800 text-center mb-6">What happens next</p>
        <div className="flex flex-col gap-4 px-8 md:px-16">
          <div className="flex items-start gap-4">
            <span className="text-blue-500 font-semibold">1</span>
            <span className="text-sm md:text-base text-slate-600">Confirm your micro-deposit amount.</span>
          </div>
          <div className="flex items-start gap-4">
            <span className="text-blue-500 font-semibold">2</span>
            <span className="text-sm md:text-base text-slate-600">Complete your verification call.</span>
          </div>
          <div className="flex items-start gap-4">
            <span className="text-blue-500 font-semibold">3</span>
            <span className="text-sm md:text-base text-slate-600">Get your collateral back.</span>
          </div>
        </div>
      </div>

      <p className="mt-8 text-sm text-slate-500 px-0 md:px-[100px]">
        Micro-deposits can take up to 24 hours to appear depending on network conditions. If it has been longer than 24 hours, call us at
        {' '}
        <a href="tel:+18447216961" className="whitespace-nowrap text-blue-500 font-semibold">
          (844) 721-6961
        </a>
        .
      </p>
    </div>
  );
};

MicroDepositOnTheWayPage.propTypes = {
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default MicroDepositOnTheWayPage;
